import { render, staticRenderFns } from "./RequestPasswordReset.vue?vue&type=template&id=3aee1060&scoped=true"
import script from "./RequestPasswordReset.vue?vue&type=script&lang=js"
export * from "./RequestPasswordReset.vue?vue&type=script&lang=js"
import style0 from "./RequestPasswordReset.vue?vue&type=style&index=0&id=3aee1060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aee1060",
  null
  
)

export default component.exports